module.exports = __webpack_public_path__ + "static/media/waterproof-armchair.80af47c9.png";